<script setup lang="ts">
import { Card, CardContent, CardFooter  } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import { useVerifyEmail, useResendVerification } from '@/composables/api/useAuthApi';
import useLogger from '@/composables/useLogger'

const logger = useLogger()
const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const { mutate: verifyEmail, isPending: isVerifying } = useVerifyEmail();
const { mutate: resendVerification, isPending: isResending } = useResendVerification();

const isLoading = computed(() => isVerifying.value || isResending.value);

onMounted(async () => {
  const { expires, signature } = route.query;
  const { id, hash } = route.params;
  logger.log('VerifyEmail', { expires, signature, id, hash })
  
  if (expires && signature && id && hash) {
    try {
      logger.log('VerifyEmail', 'Sending verification request')
      
      verifyEmail(
        {
          id: id as string,
          hash: hash as string,
          expires: expires as string,
          signature: signature as string,
        },
        {
          onSuccess: async () => {
            logger.log('VerifyEmail', 'Email verified successfully! Loading user...')
            await authStore.loadUser();
            router.push('/');
          }
        }
      );
    } catch (error) {
      logger.error('VerifyEmail', 'Verification failed', error);
    }
  }
});

const handleResendVerification = () => {
  resendVerification();
};
</script>

<template>
  <Card class="px-6 py-6">
    <CardContent class="pb-6 text-sm leading-relaxed">
      Thanks for signing up! Before getting started, could you verify your email address by
      clicking on the link we just emailed to you? If you didn't receive the email, we will gladly
      send you another.
    </CardContent>

    <CardFooter class="px-0 pb-0">
      <div class="flex items-center w-full">
        <Button 
          @click="handleResendVerification" 
          :disabled="isLoading"
          :loading="isLoading"
          class="w-full"
        >
          Resend Verification Email
        </Button>
      </div>
    </CardFooter>
  </Card>
</template>
